const styles = {

  header: {
    textAlign: 'center',
  },
  heading: {
    textAlign: 'center',
    color: 'white',
  },
  subheading: {
    justifyContent: 'center',
    position: 'relative',
    color: 'white',
    fontSize: 7,
    flexWrap: 'wrap',
  },
  bold: {
    fontWeight: 700,
  }
}

export default styles
